import { render, staticRenderFns } from "./PurimNewGift.vue?vue&type=template&id=123f78f7&"
import script from "./PurimNewGift.vue?vue&type=script&lang=js&"
export * from "./PurimNewGift.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports